import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { getErrorMessage } from './ClassForm.messages';
import _ from 'lodash';

export const ErrorMessage = ({ children }) => (
    <p className="class-form__error-message">{children}</p>
);

export const FieldErrors = ({ fieldsInvalid, property, valueFormatter = null }) => {
    const { formatMessage } = useIntl();

    return fieldsInvalid[property] ? (
        <Fragment>
            {fieldsInvalid[property].map(
                ({ code, actualProperty, values }, i) =>
                    code && (
                        <ErrorMessage data-testid={code} key={`${code}-${i}`}>
                            {formatMessage(
                                getErrorMessage(
                                    _.defaultTo(actualProperty, property),
                                    code,
                                    values
                                ),
                                { values: valueFormatter ? valueFormatter(code, values) : values }
                            )}
                        </ErrorMessage>
                    )
            )}
        </Fragment>
    ) : null;
};
